import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import {
  HeaderPage,
  TableTablesAdmin,
  AddEditTableForm,
  AreasManager,
} from "../../components/Admin";
import { ModalBasic, ModalConfirm } from "../../components/Common";
import { useTable, useAuth } from "../../hooks";
import { getAreasApi } from "../../api/area";

export function TablesAdmin() {
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const { loading, tables, getTables, deleteTable } = useTable();
  const { auth } = useAuth();
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    getTables();
    getAreasApi(auth.token)
      .then((result) => setAreas(result || []))
      .catch(() => setAreas([]));
  }, [refetch]);

  const openCloseModal = () => setShowModal((prev) => !prev);
  const onRefetch = () => setRefetch((prev) => !prev);

  const addTable = () => {
    setTitleModal("Crear mesa");
    setContentModal(
      <AddEditTableForm onClose={openCloseModal} onRefetch={onRefetch} areas={areas} />
    );
    openCloseModal();
  };

  const updateTable = (data) => {
    setTitleModal("Actualizar mesa");
    setContentModal(
      <AddEditTableForm
        onClose={openCloseModal}
        onRefetch={onRefetch}
        table={data}
        areas={areas}
      />
    );
    openCloseModal();
  };

  const onDeleteTable = (data) => setDeleteTarget(data);

  const confirmDeleteTable = async () => {
    await deleteTable(deleteTarget.id);
    setDeleteTarget(null);
    onRefetch();
  };

  return (
    <>
      <HeaderPage
        title="Mesas"
        btnTitle="Crear nueva mesa"
        btnClick={addTable}
      />

      <AreasManager areas={areas} onChange={onRefetch} />

      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <TableTablesAdmin
          tables={tables}
          updateTable={updateTable}
          deleteTable={onDeleteTable}
          onRefetch={onRefetch}
        />
      )}

      <ModalBasic
        show={showModal}
        onClose={openCloseModal}
        title={titleModal}
        children={contentModal}
      />

      <ModalConfirm
        title="¿Eliminar mesa?"
        content={`Se eliminará ${deleteTarget?.place || `la mesa ${deleteTarget?.number}`} de forma permanente.`}
        show={!!deleteTarget}
        onCloseText="Cancelar"
        onClose={() => setDeleteTarget(null)}
        onConfirmText="Eliminar"
        onConfirm={confirmDeleteTable}
      />
    </>
  );
}
